import React, { useContext } from 'react';
import { Radio } from '@hz-design-system/web-ui';
import { FaqReportingContext } from '../context/FaqReportingContext';

const ReportReason = ({ label, reason }: any) => {
  const { selectedReason, setSelectedReason } = useContext(FaqReportingContext);
  return (
    <>
      <Radio
        onChange={() => setSelectedReason(reason)}
        isChecked={selectedReason === reason}
        value={reason}
        labelText={label}
      />
    </>
  );
};

export default ReportReason;
